import {Component, ViewChild} from '@angular/core';
import {ChangePasswordCommonComponent} from '../change-password-common/change-password-common.component';
import {isNil} from 'lodash-es';

@Component({
    selector: 'app-force-change-password',
    templateUrl: './force-change-password.component.html',
    styleUrls: ['./force-change-password.component.scss'],
    standalone: false
})
export class ForceChangePasswordComponent  {

  @ViewChild('changePasswordCommonComponent')
  public readonly changePasswordCommonComponent: ChangePasswordCommonComponent;

  send() {
    this.changePasswordCommonComponent.send();
  }

  sendEnabled(): boolean {
    if (!isNil(this.changePasswordCommonComponent)) {
      return this.changePasswordCommonComponent.sendEnabled();
    }
    return false;
  }
}

